// extracted by mini-css-extract-plugin
export default {"user":"app-header_user__-gyNM","userInfo":"app-header_userInfo__Jcv1s","userName":"app-header_userName__s30jJ","userRole":"app-header_userRole__zNTVG color1"};